<template>
  <div class="color-bets">
    <div
      v-for="color in colors"
      :key="color.key"
      class="color-wrapper"
    >
      <div
        class="color-box"
        @click="handleColorClick(color.key, $event)"
        :ref="el => colorRefs[color.key] = el"
        :style="{ backgroundImage: color.gradient }"
      >
        <div class="total-bet" v-if="localBets[color.key] > 0">
          {{ formatAmount(localBets[color.key] || 0) }}
        </div>

        <div class="rocket-area">
          <img :src="color.icon" class="rocket-img" />
          <div class="join-text"> {{ $t('wingo.Join') }} {{ color.label }}</div>
        </div>

        <div class="chip-layer">
          <div
            v-for="(chip, index) in chips[color.key] || []"
            :key="index"
            class="chip"
            :style="chip.style"
          ></div>
        </div>

        <div v-if="overlayState" class="overlay" :class="overlayState">
  <img
    :src="overlayState === 'lock' ? lockImg : fastImg"

    alt="overlay"
    class="overlay-icon"
  />
</div>
      </div>

      <div class="multiplier">{{ color.multiplier }}X</div>
    </div>
  </div>
</template>

<script setup>

import { reactive, ref, computed, nextTick, onMounted } from 'vue'
import lockImg from '@/assets/img/lock.png'
import fastImg from '@/assets/img/fast.png'
import { useStore } from 'vuex'
import chipImg from '@/assets/img/chip-rivo.png'
import chipSound from '@/assets/sounds/chip.wav'

const props = defineProps({
  selected: String,
  bets: Object,
  roundId: String,
  user: Object,
  socket: Object
})

const emit = defineEmits(['select'])
const store = useStore()

const localBets = reactive({})
const colorRefs = reactive({})
const chips = reactive({})
const liveRoundId = ref(null)
let amountInputEl = null

const countdown = ref(30)

const overlayState = computed(() => {
  if (countdown.value <= 5) return 'lock'
  if (countdown.value <= 10) return 'fast'
  return null
})

onMounted(() => {
  let timerInterval = null

  amountInputEl = document.querySelector('.amount-input input')

  props.socket?.on('wingo:round:start', ({ roundId }) => {
    liveRoundId.value = roundId
      countdown.value = 30
  clearInterval(timerInterval)
  timerInterval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timerInterval)
    }
  }, 1000)
    // Round başında çipleri temizle ama bir sonraki tickte (animasyon izinsiz kaybolmasın)
    nextTick(() => {
      Object.keys(chips).forEach(key => { chips[key] = [] })
      Object.keys(localBets).forEach(key => { localBets[key] = 0 })
    })
  })

  props.socket?.on('wingo:round:active:bets', ({ bets }) => {
    for (const bet of bets) {
      if (!chips[bet.choice]) chips[bet.choice] = []
      chips[bet.choice].push({
        style: {
          top: `${Math.random() * 40 + 30}%`,
          left: `${Math.random() * 40 + 30}%`,
          backgroundImage: `url(${chipImg})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          width: '26px',
          height: '26px',
          position: 'absolute',
          zIndex: '2'
        }
      })
    }
  })

  props.socket?.on('wingo:bet:success', async () => {
    try {
      const res = await fetch('https://play.rivobit.com/auth/me', {
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      })

      if (res.ok) {
        const data = await res.json()
        store.commit('auth_set_user', data.user)
      }
    } catch (e) {
      console.error('[SOCKET] ❌ Kullanıcı verisi güncellenemedi', e)
    }
  })

  props.socket?.on('wingo:bet:error', (err) => {
    console.error('[SOCKET] ❌ Bet hatası:', err?.message)
  })

  // ✅ Geçmiş çipleri yükle (sayfa yenilendiğinde veya geç katıldığında)
 props.socket?.on('wingo:bet:sync', ({ roundId, bets }) => {
  for (const bet of bets) {
    if (!chips[bet.choice]) chips[bet.choice] = []
    chips[bet.choice].push({
      style: generateChipStyle()
    })

    if (!localBets[bet.choice]) localBets[bet.choice] = 0
    localBets[bet.choice] += bet.amount
  }
})


props.socket?.on('wingo:bet:new', ({ userId, bets }) => {
  const myUserId = props.user?._id

  // ✅ Eğer kendi kullanıcımızsa çipi tekrar eklemiyoruz
  if (userId === myUserId) return

  for (const bet of bets) {
    if (!chips[bet.choice]) chips[bet.choice] = []
    chips[bet.choice].push({
      style: generateChipStyle()
    })

    if (!localBets[bet.choice]) localBets[bet.choice] = 0
    localBets[bet.choice] += bet.amount

    if (colorRefs[bet.choice]) {
      animateFlyingChip(bet.choice)
    }
  }
})


})

const handleColorClick = (key, event) => {
  if (!props.user || !props.user._id) {
    store.dispatch('modalsSetShow', 'Login')
    return
  }

  if (countdown.value <= 5) {
    console.warn(this.$t('wingo.cannotbet'))
    return
  }

  emit('select', key)

  const amount = parseFloat(amountInputEl?.value || '0')
  if (amount <= 0) {
    console.warn(this.$t('wingo.invalidamount'), amount)
    return
  }

  const currency = props.user?.currency
  const rawWallet = props.user?.wallets?.find(w =>
    w.coinType === currency?.coinType &&
    w.chain === currency?.chain &&
    w.type === currency?.type
  )

  const balance = rawWallet?.balance || 0
  if (amount > balance) {
    store.dispatch('notificationShow', {
      type: 'error',
      message: this.$t('wingo.insufficientBalance')

    })
    return
  }

  if (!localBets[key]) localBets[key] = 0
  localBets[key] += amount

  animateFlyingChip(key, event)

  if (!chips[key]) chips[key] = []
  chips[key].push({
    style: generateChipStyle()
  })

  const token = localStorage.getItem('token')
  if (!token || !rawWallet || !props.socket || !liveRoundId.value || !currency?.fiatCurrency) {
    console.warn('[BET] Eksik bilgi:', {
      token,
      wallet: rawWallet,
      socket: !!props.socket,
      roundId: liveRoundId.value,
      currency,
      wallets: props.user?.wallets
    })
    return
  }

  const cleanWallet = {
    coinType: rawWallet.coinType,
    chain: rawWallet.chain,
    type: rawWallet.type,
    currency: currency.fiatCurrency
  }

  const betPayload = {
    token,
    bets: [
      {
        roundId: liveRoundId.value,
        betType: 'color',
        choice: key,
        amount,
        wallet: cleanWallet
      }
    ]
  }

  props.socket.emit('wingo:bet', betPayload)
}


const animateFlyingChip = async (key, event = null) => {
  const targetBox = colorRefs[key]
  if (!targetBox) return

  playChipSound()

  let startRect
  if (event && amountInputEl) {
    startRect = amountInputEl.getBoundingClientRect()
  } else {
    startRect = {
      top: window.innerHeight / 2,
      left: window.innerWidth / 2,
      width: 0,
      height: 0
    }
  }

  const endRect = targetBox.getBoundingClientRect()

  const chipEl = document.createElement('div')
  chipEl.className = 'flying-chip'
  chipEl.style.backgroundImage = `url(${chipImg})`
  chipEl.style.position = 'fixed'
  chipEl.style.width = '26px'
  chipEl.style.height = '26px'
  chipEl.style.backgroundSize = 'contain'
  chipEl.style.backgroundRepeat = 'no-repeat'
  chipEl.style.backgroundPosition = 'center'
  chipEl.style.top = `${startRect.top + startRect.height / 2 + window.scrollY - 13}px`
  chipEl.style.left = `${startRect.left + startRect.width / 2 + window.scrollX - 13}px`
  chipEl.style.transition = 'transform 0.6s ease, opacity 0.6s ease'
  chipEl.style.opacity = '0'
  chipEl.style.zIndex = '99999'
  chipEl.style.pointerEvents = 'none'

  document.body.appendChild(chipEl)

  await nextTick()

  requestAnimationFrame(() => {
    const deltaX = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2)
    const deltaY = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2)
    chipEl.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.6)`
    chipEl.style.opacity = '1'
  })

  setTimeout(() => {
    document.body.removeChild(chipEl)
  }, 600)
}

const generateChipStyle = () => ({
  top: `${Math.random() * 40 + 30}%`,
  left: `${Math.random() * 40 + 30}%`,
  backgroundImage: `url(${chipImg})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  width: '26px',
  height: '26px',
  position: 'absolute',
  zIndex: '2'
})

const playChipSound = () => {
  const audio = new Audio(chipSound)
  audio.volume = 0.4
  audio.play().catch(() => {})
}

const formatAmount = (val) => {
  if (val >= 1000) return (val / 1000).toFixed(1) + 'k'
  return val.toFixed(0)
}

const colors = [
  {
    key: 'green',
    label: 'Green',
    multiplier: 1.92,
    icon: new URL('@/assets/img/rocket-green.webp', import.meta.url).href,
    gradient: 'linear-gradient(rgba(36, 238, 137, 0.3) 0%, rgba(36, 238, 137, 0.05) 100%)'
  },
  {
    key: 'violet',
    label: 'Violet',
    multiplier: 4.5,
    icon: new URL('@/assets/img/rocket-purple.webp', import.meta.url).href,
    gradient: 'linear-gradient(rgba(174, 77, 228, 0.3) 0%, rgba(174, 77, 228, 0.05) 100%)'
  },
  {
    key: 'red',
    label: 'Red',
    multiplier: 1.92,
    icon: new URL('@/assets/img/rocket-red.webp', import.meta.url).href,
    gradient: 'linear-gradient(rgba(255, 68, 68, 0.3) 0%, rgba(255, 68, 68, 0.05) 100%)'
  }
]
</script>







<style scoped>
.color-bets {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  
}

.color-box {
  flex: 1;
  position: relative;
  
  width: 100%;
  border-radius: 12px;
  background-size: cover;
  background-position: center;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease;
  border: 2px solid transparent;
  overflow: visible;
  z-index: 0;
}



.total-bet {
  position: absolute;
  top: -10px;
  right: -10px;
  background: var(--background);
  color: #fff;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  z-index: 2;
}

.rocket-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.color-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rocket-img {
  width: 56px;
  height: 56px;
  margin-bottom: 6px;
  z-index: 2;
}

.join-text {
  color: white;
  font-size: 13px;
  font-weight: bold;
  z-index: 2;
}

.multiplier {
  margin-top: 10px;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
}

.chip-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.chip {
  position: absolute;
  width: 26px;
  height: 26px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 11;
}

.flying-chip {
  position: fixed;
  width: 26px;
  height: 26px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.6s ease, opacity 0.6s ease;
  z-index: 99999;
  pointer-events: none;
  opacity: 0;
}

.overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.411);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  border-radius: 12px;
  transition: background-color 0.3s ease;
}

.overlay.fast {
  background-color: rgba(0, 0, 0, 0.411);
}

.overlay.lock {
  background-color: rgba(0, 0, 0, 0.4);
}

.overlay-icon {
  width: 46px;
  height: 46px;
  opacity: 0.8;
}
</style>